import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../../services/authentication/auth-service.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private authservice: AuthService) {}

    canActivate(): boolean {
        // if (localStorage.getItem('isLoggedin')) {
        if (this.authservice.isAuthenticated() === true){
            return true;
        }
        if (localStorage.getItem('token') != null && localStorage.getItem('token') !== undefined) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}
